import { render } from "./OfferingDisclosure.vue?vue&type=template&id=3848334c&scoped=true"
import script from "./OfferingDisclosure.vue?vue&type=script&lang=js"
export * from "./OfferingDisclosure.vue?vue&type=script&lang=js"

import "./OfferingDisclosure.vue?vue&type=style&index=0&id=3848334c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3848334c"

export default script